import Vue from 'vue';
import store from '../store/index.js';
import {
    GeneralStorageKeys,
} from '../enums.js';
import LoadingEl from '../components/Elements/SavingEl.vue';
import _cookies from '../helpers/cookies';
import BrowserStorage from '../helpers/browserStorage';
import queryString from 'query-string';

new Vue({
    el: '#shell-wrapper',
    store,
    template: '<div><LoadingEl></LoadingEl></div>',
    data: function() {
        return {
            config: store.getters.getGlobalConfig,
        };
    },
    methods: {

    },
    mounted: function () {
        //When app is ready

        var team = null;
        var account = null;

        if( !BrowserStorage.getItem('hopper_user_home_page') ) {
            BrowserStorage.setItem('hopper_user_home_page', 'calendar');
        }

        let homepage = 'posts';
        if(BrowserStorage.getItem('hopper_user_home_page')){
            homepage = BrowserStorage.getJsonItem('hopper_user_home_page');
        }

        let routerMode = BrowserStorage.getItem(GeneralStorageKeys.ROUTER_MODE);
        if( routerMode === null ) {
            routerMode = true;
            BrowserStorage.setItem(GeneralStorageKeys.ROUTER_MODE, true);
        } else {
            routerMode = JSON.parse(routerMode);
        }
        homepage = `${routerMode?'app/':''}${homepage}`;

        //SET TEAM

        //Team Cookie
        let teamCookie = _cookies.get('hopper_current_team');

        if(window.HOPPER_CONTEXT.params.teamId != null && window.HOPPER_CONTEXT.params.teamId != 'undefined' && window.HOPPER_CONTEXT.params.teamId != '') {
            team = window.HOPPER_CONTEXT.params.teamId;
        } else if (teamCookie) {
            team = teamCookie;
        }

        //SET ACCOUNT

        var personalAccountCookie = _cookies.get('hopper_current_account__user');
        var teamAccountCookie = _cookies.get('hopper_current_account__' + team);

        if(window.HOPPER_CONTEXT.params.accountId) {
            account = window.HOPPER_CONTEXT.params.accountId;
        } else if (team && teamAccountCookie) {
            account = teamAccountCookie;
        } else if (personalAccountCookie) {
            account = personalAccountCookie;
        } else {
            account = '';
        }

        const query = queryString.stringify(
            Object.assign(window.HOPPER_CONTEXT.query, {
                accountId: account,
            }),
        );

        window.location = `${team ? `/teams/${team}`:''}/${homepage}?${query}`;
    },
    components: { LoadingEl  },
});
